import React, { useContext } from "react";
import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { List } from "./List";

const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const WaitingListPreview = ({
    formLang,
}) => {
    const { waitingListFlowContext } = useContext(WaitingListFlowContext);

    const listSelectionRows = [
        {
            left: formLang.facility,
            right: waitingListFlowContext?.facility?.name,
        },
        {
            left: formLang.product,
            right:
                waitingListFlowContext?.product?.OverviewText ??
                waitingListFlowContext?.product?.Text,
        },
        {
            left: formLang.descriptionText,
            right: waitingListFlowContext?.product?.Description,
        },
        {
            left: formLang.numberOfParkingSpots,
            right: 1,
        },
    ];

    return (
        <div className="waitinglistflowpage__preview">
            <div className="waitinglistflowpage__preview__list">
                <List rows={listSelectionRows} />
            </div>
        </div>
    );
};
